import React, { useRef, memo } from 'react';
import { Button, ConfirmModal, TextArea } from '@miroculus/nucleo';
const FinishModal = memo(({ onConfirmClick, onCancelClick, feedback, onFeedbackChange, }) => {
    const cancelRef = useRef(null);
    return (React.createElement(ConfirmModal, { level: "info", label: "If you finish the experiment, your progress will be lost.", description: "Could you leave use some feedback?", leastDestructiveRef: cancelRef },
        React.createElement(TextArea, { placeholder: "Tell us how was everything ...", value: feedback, onChange: (evt) => {
                onFeedbackChange(evt.target.value);
            }, maxLength: 1000 }),
        React.createElement(Button, { ref: cancelRef, size: "small", onClick: onCancelClick, flavor: "secondary" }, "Cancel"),
        React.createElement(Button, { size: "small", onClick: onConfirmClick, flavor: "primary", "data-testid": "confirm-button" }, "Finish")));
});
export default FinishModal;
